"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSRequest = exports.WSChannel = void 0;
var WSChannel;
(function (WSChannel) {
    WSChannel["candlesticks"] = "candlesticks";
    WSChannel["books"] = "books";
    WSChannel["recent_trades"] = "recent_trades";
    WSChannel["orders"] = "orders";
    WSChannel["orders_by_market"] = "orders_by_market";
    WSChannel["balances"] = "balances";
    WSChannel["account_trades"] = "account_trades";
    WSChannel["account_trades_by_market"] = "account_trades_by_market";
    WSChannel["market_stats"] = "market_stats";
    WSChannel["market_stats_by_market"] = "market_stats_by_market";
    WSChannel["leverages"] = "leverages";
    WSChannel["leverages_by_market"] = "leverages_by_market";
    WSChannel["positions"] = "positions";
    WSChannel["positions_by_market"] = "positions_by_market";
    WSChannel["pools"] = "pools";
    WSChannel["pools_by_id"] = "pools_by_id";
    WSChannel["token_prices"] = "token_prices";
    WSChannel["token_prices_by_denom"] = "token_prices_by_denom";
    WSChannel["commitments"] = "commitments";
    WSChannel["cdp_borrows"] = "cdp_borrows";
    WSChannel["cdp_collaterals"] = "cdp_collaterals";
    WSChannel["cdp_liquidate_collaterals"] = "cdp_liquidate_collaterals";
    WSChannel["cdp_token_debts"] = "cdp_token_debts";
    WSChannel["cdp_token_debts_by_denom"] = "cdp_token_debts_by_denom";
    WSChannel["cdp_reward_schemes"] = "cdp_reward_schemes";
    WSChannel["cdp_reward_debts"] = "cdp_reward_debts";
    WSChannel["cdp_token_supply"] = "cdp_token_supply";
    WSChannel["cdp_token_supply_by_denom"] = "cdp_token_supply_by_denom";
})(WSChannel = exports.WSChannel || (exports.WSChannel = {}));
var WSRequest;
(function (WSRequest) {
    WSRequest["MarketStats"] = "get_market_stats";
    WSRequest["OrderHistory"] = "get_order_history";
    WSRequest["RecentTrades"] = "get_recent_trades";
    WSRequest["Candlesticks"] = "get_candlesticks";
    WSRequest["OpenOrders"] = "get_open_orders";
    WSRequest["AccountTrades"] = "get_account_trades";
    WSRequest["Leverages"] = "get_leverages";
    WSRequest["Positions"] = "get_positions";
    WSRequest["OpenPositions"] = "get_open_positions";
    WSRequest["ClosedPosition"] = "get_closed_positions";
    WSRequest["Balances"] = "get_balances";
    WSRequest["OrderBook"] = "get_orderbook";
    WSRequest["Pools"] = "get_pools";
    WSRequest["Commitments"] = "get_commitments";
    WSRequest["CDPAllAssets"] = "get_cdp_all_assets";
    WSRequest["CDPAssets"] = "get_cdp_assets";
    WSRequest["CDPAccountCollaterals"] = "get_cdp_account_collaterals";
    WSRequest["CDPAccountDebts"] = "get_cdp_account_debts";
    WSRequest["CDPAccountData"] = "get_cdp_account_data";
    WSRequest["CDPParams"] = "get_cdp_params";
    WSRequest["CDPAllRateStrategies"] = "get_cdp_all_rate_strategies";
    WSRequest["CDPRateStrategies"] = "get_cdp_rate_strategies";
    WSRequest["CDPBorrows"] = "get_cdp_borrows";
    WSRequest["CDPTotalBorrows"] = "get_cdp_total_borrows";
    WSRequest["CDPCollaterals"] = "get_cdp_collaterals";
    WSRequest["CDPTotalCollaterals"] = "get_cdp_total_collaterals";
    WSRequest["CDPLiquidateCollateral"] = "get_cdp_liquidate_collateral";
    WSRequest["CDPTokenDebt"] = "get_cdp_token_debt";
    WSRequest["CDPAllTokenDebts"] = "get_cdp_all_token_debts";
    WSRequest["CDPStablecoinDebt"] = "get_cdp_stablecoin_debt";
    WSRequest["CDPLiquidations"] = "get_cdp_liquidations";
    WSRequest["CDPAccountStablecoin"] = "get_cdp_account_stablecoin";
    WSRequest["CDPRewardSchemes"] = "get_cdp_reward_schemes";
    WSRequest["CDPRewardsDebts"] = "get_cdp_reward_debts";
})(WSRequest = exports.WSRequest || (exports.WSRequest = {}));
